/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_DECOSTITCH_APPLIED = "SET_DECOSTITCH_APPLIED";

export const SET_UPGRADE_OPTIONS = "SET_UPGRADE_OPTIONS";

export const SET_COMPONENT_DISABLED = "SET_COMPONENT_DISABLED";
